import { createUseStyles } from 'react-jss';

export const useOverlayStyles = createUseStyles({
  root: {
    bottom: '0',
    left: '0',
    position: 'fixed',
    top: '0',
    transform: ({ isTransitionedIn }: { isTransitionedIn: boolean }) =>
      isTransitionedIn ? 'unset' : 'translateX(-100%)',
    transition: 'transform 0.3s ease',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
  },
  overlay: {
    bottom: 'unset',
    left: 'unset',
    position: 'unset',
    right: 'unset',
    top: 'unset',
  },
  closeButton: {
    background: 'inherit',
    cursor: 'pointer',
    margin: '-5px',
    padding: '5px',
    position: 'absolute',
    right: '30px',
    top: '30px',
    border: 'none',
  },
});
